import { useState } from 'react';

export function useGuestId(storageKey = 'ai-chat-guest-id'): string {
  const [guestId] = useState<string>(() => {
    try {
      let storedId = localStorage.getItem(storageKey);
      if (!storedId) {
        const generatedId =
          typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
        storedId = generatedId;
        localStorage.setItem(storageKey, storedId);
      }
      return storedId;
    } catch (error) {
      console.warn('Unable to initialize guest identifier', error);
      return 'public';
    }
  });

  return guestId;
}
